import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MenuService } from '@app/core/menu/menu.service';

export const homePolicyGuard: CanActivateFn = (route, state) => {
  
  const router = inject(Router);
  const menuService = inject(MenuService);

  const menu = menuService.getMenu();
  const path = menu?.length ? menu[0].link : "/not-allowed";

  router.navigate([path]);
  return false;

};
